module.exports = __webpack_public_path__ + "static/media/barcode.b4e7f305.jpeg";